export function readText(text: string) {
    const synthesis = window.speechSynthesis;
    if (!synthesis) {
        console.debug('speechSynthesis is not available')
        return
    }
    if (synthesis.pending) {
        synthesis.cancel();
    }
    const voices = synthesis.getVoices();
    const voice = voices.filter(v => v.default);
    if (voice) {
        const utterThis = new SpeechSynthesisUtterance();
        utterThis.text = text;
        utterThis.lang = 'es-ES';
        synthesis.speak(utterThis);
        let r = setInterval(() => {
            if (!synthesis.speaking) {
                clearInterval(r);
            } else {
                synthesis.pause();
                synthesis.resume();
            }
        }, 14000);
    }
}